import axios from 'axios'
import {asResponse} from '../util'
import {mutate} from 'swr'

export const VERSION_SWR_KEY = ({versionId}) => [
  '/bff/versions/${versionId}?load=contract,environments',
  versionId
]

export const getVersion = async (url, versionId) => {
  if (!versionId) {
    return {
      version: undefined
    }
  }
  const resp = await asResponse(axios.get(url.replace('${versionId}', versionId)))
  return {
    version: resp.data
  }
}

export const getVersionById = async (versionId) => {
  const resp = await asResponse(axios.get(`/bff/versions/${versionId}`))
  return resp.data
}

export const mutateVersion = async function () {
  let args = Array.from(arguments)
  const versionId = args[args.length - 1]
  const key = VERSION_SWR_KEY({versionId})
  args = [key, ...args]
  return mutate.apply(this, args)
}

export const upsertVersion = async (version) => {
  const verb = version.id ? 'put' : 'post'
  const path = version.id ? `/bff/versions/${version.id}` : `/bff/versions`
  const resp = await asResponse(axios[verb](`${path}?buildDefaultEnvironment=true`, version))
  return resp.data
}

export const removeVersion = async (versionId) => {
  return axios.delete(`/bff/versions/${versionId}`)
}

export const archiveVersion = async (versionId) => {
  const resp = await asResponse(axios.post('/bff/versions/archive', {versionId}))
  return resp.data
}

export const cloneVersion = async (versionId) => {
  const resp = await asResponse(axios.post(`/bff/versions/clone`, {id: versionId}))
  return resp.data
}

export const publishVersion = async (serviceId, versionId) => {
  await asResponse(axios.post(`/bff/versions/publish`, {serviceId, versionId}))
}
